import queryString from 'query-string';

import { DateRange, removeEmptyKeys } from '@app/utils';
import { SortDirection, URLQuery } from '@app/constants';

import { SearchState, SelectedFacets, SortField } from '../../constants';

const stringifySortState = (
  sortField: SortField = SortField.relevance,
  sortDirection: SortDirection = SortDirection.asc
) => {
  if (sortField === SortField.relevance) {
    return '';
  }

  const sortPrefix = sortDirection === SortDirection.desc ? '-' : '';

  return `${sortPrefix}${sortField}`;
};

export const stringifyFacetsForUrl = (selectedFacets?: SelectedFacets) =>
  selectedFacets &&
  queryString.stringify(selectedFacets, {
    arrayFormat: 'bracket-separator',
  });

export const stringifyPublicationYear = (publicationYear?: DateRange) =>
  publicationYear && queryString.stringify(removeEmptyKeys(publicationYear));

export const getURLState = ({
  query,
  option,
  sortField,
  sortDirection,
  facets,
  publicationYear,
  pageNumber,
  recordsPerPage,
}: Partial<SearchState>): URLQuery => {
  const sort = stringifySortState(sortField, sortDirection);

  return removeEmptyKeys({
    query,
    option,
    sort,
    publicationYear: stringifyPublicationYear(publicationYear),
    facets: stringifyFacetsForUrl(facets),
    pageNumber: pageNumber?.toString(),
    recordsPerPage: recordsPerPage?.toString(),
  });
};
